module.exports = __webpack_public_path__ + "static/media/world-thai-chi.f824d57c.mp4";